import Vue from 'vue'
import Router from 'vue-router'

var routerMethod = '',
    store = null

// mutate router method
function proxyMethod(method, fn) {
    return function(location, onComplete, onAbort) {
        // 记录最近一次路由动作名称
        routerMethod = method

        // 兼容vue-router2.0 回调写法
        var result = fn.call(this, location, onComplete, onAbort)

        if (result && result.then) {
            result = result.catch(err => {
                // 自vue-router3.1之后navigation failure也会抛出Error
                // 实际开发不需要这个，在此吞掉异常
                // vue-router4.0 会修复这个问题
                if(err && err._isRouter){
                    return
                }

                return Promise.reject(err)
            })
        }

        return result
    }
}

// mutate
Router.prototype.push = proxyMethod("push", Router.prototype.push)
Router.prototype.replace = proxyMethod("replace", Router.prototype.replace)
Router.prototype.go = proxyMethod("go", Router.prototype.go)

// 重建路由实例
export function resetRouter(router, options) {
    const newRouter = genRouter(options)

    // 相当于只重新构建routes
    router.matcher = newRouter.matcher
}

// 创建路由实例
export function genRouter(options = {}) {
    var router = new Router({
        mode: options.mode || 'history',
        base: options.base || "/",
        routes: options.routes || [],
    })

    router.afterEach(to => {
        if (store) {
            store.commit("setRouterMethod", routerMethod)
        }
    })

    return router
}

// create router
export default function(options) {
    Vue.use(Router)
    
    store = options.store

    // expose 
    Vue.$router = genRouter({
        mode: options.mode,
        base: options.base,
        routes: options.routes,
    })

    return Vue.$router
}